/* ============================================================
   PASMO · tema Shopify
   Animaciones de scroll, carrito AJAX y ficha de producto.
   Solo se animan transform y opacity.
   ============================================================ */
(function () {
  "use strict";

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

  /* ---------- Dinero ---------- */
  function money(cents) {
    return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(cents / 100);
  }

  /* ============================================================
     Pieza 3D de la portada: la P del logo en capas reales
     ============================================================ */
  const P_PATH = "M15 17h20c7.7 0 14 6.3 14 14s-6.3 14-14 14H26v12H15V17zm11 8v12h9a6 6 0 000-12h-9z";
  function buildObject() {
    const obj = $("#obj");
    if (!obj) return;
    const N = reduced ? 12 : 26;
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill="#000" fill-rule="evenodd" d="${P_PATH}"/></svg>`;
    const mask = `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}")`;
    const BOT = [0x4b, 0x21, 0xd9], MID = [0x1d, 0x4e, 0xf5], TOP = [0x35, 0xb4, 0xff];
    const mix = (a, b, u) => a.map((v, k) => Math.round(v + (b[k] - v) * u));
    const ramp = t => (t < 0.55 ? mix(BOT, MID, t / 0.55) : mix(MID, TOP, (t - 0.55) / 0.45));
    const rgb = (c, m) => `rgb(${c.map(v => Math.round(Math.min(255, v * m))).join(",")})`;
    const frag = document.createDocumentFragment();
    for (let i = 0; i < N; i++) {
      const t = i / (N - 1), c = ramp(t), d = document.createElement("div");
      d.className = "obj__layer";
      d.style.webkitMaskImage = mask;
      d.style.maskImage = mask;
      d.style.transform = `translateZ(${(i - (N - 1) / 2) * 2.2}px)`;
      d.style.background = `linear-gradient(140deg,${rgb(c, 1.12)} 0%,${rgb(c, 1)} 46%,${rgb(c, 0.78)} 100%)`;
      if (i === N - 1) d.style.background = `linear-gradient(140deg,#9BE0FF,${rgb(c, 1.06)})`;
      frag.appendChild(d);
    }
    obj.appendChild(frag);
  }

  /* ============================================================
     Sección oscura: la P se imprime capa a capa
     ============================================================ */
  const LY = { list: [], last: -1, N: 40, LH: 0.72 };
  function buildInit() {
    LY.list = $$("#stack .ly");
    if (!LY.list.length) return;
    LY.N = LY.list.length;
    const hot = $("#hotLayer");
    if (hot) hot.dataset.iso = hot.getAttribute("transform");
    if (reduced) {
      LY.list.forEach(l => (l.style.opacity = "1"));
      const pct = $("#buildPct");
      if (pct) pct.textContent = "Capa 195";
      return;
    }
    LY.list.forEach(l => (l.style.opacity = "0"));
  }
  function buildTo(prog) {
    if (!LY.list.length || reduced) return;
    const k = Math.min(LY.N - 1, Math.floor(prog * LY.N));
    if (k !== LY.last) {
      if (k > LY.last) for (let i = Math.max(0, LY.last + 1); i <= k; i++) LY.list[i].style.opacity = "1";
      else for (let i = LY.last; i > k; i--) LY.list[i].style.opacity = "0";
      LY.last = k;
    }
    const up = k * LY.LH, live = prog > 0.004 && prog < 0.996;
    const hot = $("#hotLayer"), noz = $("#nozzle");
    if (hot) {
      hot.setAttribute("transform", `translate(0 ${(-up).toFixed(2)}) ${hot.dataset.iso}`);
      hot.style.opacity = live ? ".55" : "0";
    }
    if (noz) {
      const fr = prog * LY.N - k;
      const zig = (k % 2 ? 1 - fr : fr) * 18 - 9;
      noz.setAttribute("transform", `translate(${(60 + zig).toFixed(2)} ${(90 - up).toFixed(2)})`);
      noz.style.opacity = live ? "1" : "0";
    }
    const pct = $("#buildPct");
    if (pct) pct.textContent = "Capa " + Math.round(k * 5);
  }

  /* ============================================================
     Scroll
     ============================================================ */
  let ticking = false;
  const onScroll = () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } };

  function update() {
    ticking = false;
    const y = window.scrollY, vh = window.innerHeight;
    const nav = $("#nav");
    if (nav) {
      nav.classList.toggle("scrolled", y > 20);
      const dk = $("#shopify-section-capas") || $("#capas");
      if (dk) {
        const r = dk.getBoundingClientRect();
        nav.classList.toggle("nav--dark", r.top <= 56 && r.bottom >= 56);
      }
    }
    if (reduced) return;

    const p = clamp(y / (vh * 0.9), 0, 1);
    const copy = $("#heroCopy"), obj = $("#obj"), stage = $("#stage"), hint = $("#hint"), noz3d = $("#nozzle3d");
    if (copy) {
      copy.style.opacity = String(1 - clamp(p * 1.5, 0, 1));
      copy.style.transform = `translate3d(0,${-p * 70}px,0)`;
    }
    if (obj) obj.style.transform = `rotateX(${14 - p * 10}deg) rotateY(${-26 + p * 150}deg) scale(${1 - p * 0.12})`;
    if (stage) stage.style.transform = `translate3d(${p * 4}vw,${-p * 40}px,0)`;
    if (hint) hint.style.opacity = String(1 - clamp(p * 3, 0, 1));
    if (noz3d) {
      noz3d.style.opacity = String(1 - clamp(p * 2.4, 0, 1));
      noz3d.style.transform = `translate3d(-46%,${-p * 60}px,0)`;
    }

    const track = $("#buildTrack");
    if (track) {
      const r = track.getBoundingClientRect(), span = r.height - vh;
      if (span > 0) buildTo(clamp(-r.top / span, 0, 1));
    }
  }

  /* ---------- Aparición de elementos ---------- */
  let io;
  function observeReveals() {
    if (!io) {
      io = new IntersectionObserver(es => {
        es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
      }, { rootMargin: "0px 0px -12% 0px", threshold: 0.12 });
    }
    $$(".rv:not(.in)").forEach(el => io.observe(el));
  }

  /* ============================================================
     Carrito (API AJAX de Shopify)
     ============================================================ */
  const Cart = {
    open() {
      $("#drawer").classList.add("open"); $("#scrim").classList.add("open");
      $("#drawer").setAttribute("aria-hidden", "false");
      document.body.classList.add("is-locked");
    },
    close() {
      $("#drawer").classList.remove("open"); $("#scrim").classList.remove("open");
      $("#drawer").setAttribute("aria-hidden", "true");
      document.body.classList.remove("is-locked");
    },
    async add(id, qty) {
      const r = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
      });
      if (!r.ok) throw new Error("add");
      await this.refresh();
      this.open();
    },
    async change(key, qty) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await this.refresh();
    },
    async refresh() {
      const cart = await (await fetch("/cart.js", { headers: { Accept: "application/json" } })).json();
      const dot = $("#cartDot"), body = $("#cartBody");
      if (dot) { dot.textContent = cart.item_count; dot.classList.toggle("on", cart.item_count > 0); }
      if ($("#cartTotal")) $("#cartTotal").textContent = money(cart.total_price);
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<p class="empty">Tu carrito está vacío.<br>Empieza por las colecciones.</p>';
        return;
      }
      body.innerHTML = cart.items.map(it => `
        <div class="line">
          <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : ""}" alt="" width="56" height="56">
          <div><b>${it.product_title}</b><small>${it.variant_title || ""} · ${money(it.final_price)}</small></div>
          <div class="line__q">
            <button data-k="${it.key}" data-q="${it.quantity - 1}" aria-label="Quitar uno">−</button>
            <span>${it.quantity}</span>
            <button data-k="${it.key}" data-q="${it.quantity + 1}" aria-label="Añadir uno">+</button>
          </div>
        </div>`).join("");
      $$("button[data-k]", body).forEach(b =>
        b.addEventListener("click", () => Cart.change(b.dataset.k, Number(b.dataset.q))));
    }
  };

  /* ============================================================
     Tarjetas de producto y ficha
     ============================================================ */
  function wireCards(scope) {
    $$("[data-product-card]", scope || document).forEach(card => {
      const img = $(".p__media img", card), add = $("[data-add]", card);
      $$(".sw button", card).forEach(b => {
        b.addEventListener("click", () => {
          $$(".sw button", card).forEach(x => x.setAttribute("aria-checked", "false"));
          b.setAttribute("aria-checked", "true");
          if (add) add.dataset.add = b.dataset.variant;
          if (img && b.dataset.media) img.src = b.dataset.media;
        });
      });
      if (add) add.addEventListener("click", async () => {
        const old = add.textContent;
        add.textContent = "…";
        try {
          await Cart.add(add.dataset.add, 1);
          add.textContent = "Añadido"; add.classList.add("done");
        } catch (e) { add.textContent = "Error"; }
        setTimeout(() => { add.textContent = old; add.classList.remove("done"); }, 1500);
      });
      const fav = $(".p__fav", card);
      if (fav) fav.addEventListener("click", () => {
        const on = fav.classList.toggle("on");
        fav.setAttribute("aria-pressed", String(on));
        try {
          const key = "pasmo:fav";
          const list = new Set(JSON.parse(localStorage.getItem(key) || "[]"));
          on ? list.add(fav.dataset.fav) : list.delete(fav.dataset.fav);
          localStorage.setItem(key, JSON.stringify(Array.from(list)));
        } catch (e) {}
      });
    });
    try {
      const list = new Set(JSON.parse(localStorage.getItem("pasmo:fav") || "[]"));
      $$(".p__fav").forEach(f => {
        if (list.has(f.dataset.fav)) { f.classList.add("on"); f.setAttribute("aria-pressed", "true"); }
      });
    } catch (e) {}
  }

  function wirePDP() {
    const form = $("#pdpForm"), data = $("#pdpData");
    if (!form || !data) return;
    const variants = JSON.parse(data.textContent);
    const chosen = [];
    $$(".pdp__vals").forEach((group, gi) => {
      const on = $(".pdp__val.on", group);
      chosen[gi] = on ? on.dataset.value : null;
      $$(".pdp__val", group).forEach(b => b.addEventListener("click", () => {
        $$(".pdp__val", group).forEach(x => x.classList.remove("on"));
        b.classList.add("on");
        chosen[gi] = b.dataset.value;
        sync();
      }));
    });
    function sync() {
      const v = variants.find(x => chosen.every((c, i) => c === null || x.options[i] === c));
      const add = $("#pdpAdd"), price = $("#pdpPrice");
      if (!v) return;
      $("#pdpVariant").value = v.id;
      if (price) price.textContent = money(v.price);
      if (add) {
        add.disabled = !v.available;
        add.textContent = v.available ? "Añadir al carrito" : "Agotado";
      }
      if (v.featured_image) {
        const img = $(".product__media img");
        if (img) img.src = v.featured_image.src;
      }
    }
    form.addEventListener("submit", async e => {
      e.preventDefault();
      const add = $("#pdpAdd");
      add.textContent = "…";
      try {
        await Cart.add($("#pdpVariant").value, 1);
        add.textContent = "Añadido";
      } catch (err) { add.textContent = "Error"; }
      setTimeout(() => (add.textContent = "Añadir al carrito"), 1500);
    });
    sync();
  }

  /* ============================================================
     Init
     ============================================================ */
  function init() {
    buildObject();
    buildInit();
    observeReveals();
    wireCards();
    wirePDP();
    Cart.refresh();

    addEventListener("scroll", onScroll, { passive: true });
    addEventListener("resize", onScroll, { passive: true });
    update();

    const sheet = $("#sheet"), burger = $("#burger");
    const toggleSheet = open => {
      sheet.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", String(open));
      document.body.classList.toggle("is-locked", open);
    };
    if (burger) {
      burger.addEventListener("click", () => toggleSheet(!sheet.classList.contains("open")));
      $("#sheetClose").addEventListener("click", () => toggleSheet(false));
      $$("#sheet a").forEach(a => a.addEventListener("click", () => toggleSheet(false)));
    }
    const cartBtn = $("#cartBtn");
    if (cartBtn) cartBtn.addEventListener("click", () => Cart.open());
    if ($("#drawerClose")) $("#drawerClose").addEventListener("click", () => Cart.close());
    if ($("#scrim")) $("#scrim").addEventListener("click", () => Cart.close());
    addEventListener("keydown", e => { if (e.key === "Escape") { Cart.close(); if (sheet) toggleSheet(false); } });

    // el editor de temas recarga secciones sueltas
    document.addEventListener("shopify:section:load", () => {
      buildObject(); buildInit(); observeReveals(); wireCards(); wirePDP(); update();
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
